import React, { useEffect, useState } from "react";
import "./Product_info.css";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Demo_Product from "../../home/demo_product/Demo_Product";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { useNavigate } from "react-router-dom";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategories } from "../../../features/master/masterSlice";
import { getHomeBanner } from "../../../features/home/homeSlice";
import { postCart } from "../../../features/cart/cartSlice";
import Demo_ProductCategory from "../../home/demo_product/Demo_ProductCategory";
import { variant_type } from "../../../utils/common";

const Product_info = ({
  selectedVariant,
  setSelectedVariant,
  activeSize,
  activeTriple,
  activeMetal,
  setActiveTriple,
  setActiveSize,
  setActiveMetal,
  product,
  avg_rating,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeIndex2, setActiveIndex2] = useState(0);

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-cart?product_id=${product?.id}`);
  };

  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1);
  const isSignIn = useSelector((state) => state.auth.is_signin);

  const addToCart = async () => {
    try {
      const data = {
        product_id: product.id,
        variant_type_id: product.variant_type_id,
        quantity: quantity,
      };
      if (Number(product.variant_type_id) === variant_type.Single) {
        data.variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Double) {
        data.d_variant_id = selectedVariant?.id;
      } else if (Number(product.variant_type_id) === variant_type.Triple) {
        data.t_variant_id = selectedVariant?.id;
      }
      const res = await dispatch(postCart({ data: data, isSignIn: isSignIn }));

      if (res.meta?.requestStatus === "fulfilled") {
        handleClick();
      } else if (res.meta?.requestStatus === "rejected") {
        console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  useEffect(() => {
    if (activeMetal?.Double_Variants?.length > 0) {
      setSelectedVariant(activeMetal?.Double_Variants?.[0]);
      setActiveSize(activeMetal?.Double_Variants?.[0]);
    }
  }, [activeMetal]);

  useEffect(() => {
    if (setActiveSize?.Triple_Variants?.length > 0) {
      setSelectedVariant(setActiveSize?.Triple_Variants?.[0]);
      setActiveTriple(setActiveSize?.Triple_Variants?.[0]);
    }
  }, [setActiveSize]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "₹";

  return (
    <section className="product-details-wrapper">
      <div className="Product_info">
        <div className="text_holder">
          {/* Amazon style title */}
          <h4 className="product_main_title">{product?.name}</h4>

          <div className="rating_holder">
            <Rating
              className="star_icons"
              initialRating={Number(avg_rating?.average_rating)}
              emptySymbol={<FontAwesomeIcon icon={farStar} />}
              fullSymbol={<FontAwesomeIcon icon={fasStar} />}
              fractions={2}
              readonly
            />
            <span className="review_count">
              {avg_rating?.total_counts} ratings
            </span>
          </div>

          <hr className="ui_divider" />

          {selectedVariant && (
            <div className="amazon_price_section">
              <div className="price_row">
                <span className="discount_tag">
                  -
                  {Math.round(
                    ((selectedVariant.mrp - selectedVariant.price) /
                      selectedVariant.mrp) *
                      100,
                  )}
                  %
                </span>
                <span className="main_price">
                  <span className="currency_symbol">{symbol}</span>
                  {Number(selectedVariant.price * rate).toFixed(2)}
                </span>
              </div>
              <div className="mrp_row">
                M.R.P.:{" "}
                <span className="strikethrough">
                  {symbol}
                  {Number(selectedVariant.mrp * rate).toFixed(2)}
                </span>
              </div>
              <p className="tax_text">Inclusive of all taxes</p>
            </div>
          )}
        </div>

        <hr className="ui_divider" />

        <div className="selection_container">
          {/* METAL SECTION */}
          <div className="quantity_holder">
            <p className="type_text">
              {product?.variant_name || "Variant"}:{" "}
              <strong>{activeMetal?.Metal?.name}</strong>
            </p>
            <div className="variant_pill_grid">
              {product?.Product_Variants?.map((option) => (
                <div
                  key={option.id}
                  className={`variant_pill ${
                    activeMetal?.id === option.id ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveMetal(option);
                    if (product?.variant_type_id === variant_type.Single) {
                      setSelectedVariant(option);
                    }
                  }}
                >
                  {option?.Metal?.name}
                </div>
              ))}
            </div>
          </div>

          {/* SIZE SECTION */}
          {product?.Product_Variants?.find((v) => v.id === activeMetal?.id)
            ?.Double_Variants?.length > 0 && (
            <div className="quantity_holder">
              <p className="type_text">
                Size: <strong>{activeSize?.Size?.name}</strong>
              </p>
              <div className="variant_pill_grid">
                {product.Product_Variants.find(
                  (v) => v.id === activeMetal?.id,
                ).Double_Variants.map((item) => (
                  <div
                    key={item.id}
                    className={`variant_pill ${
                      activeSize?.id === item.id ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveSize(item);
                      if (product?.variant_type_id === variant_type.Double) {
                        setSelectedVariant(item);
                      }
                    }}
                  >
                    {item?.Size?.name}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* TRIPLE SECTION */}
          {product?.Product_Variants?.find(
            (v) => v.id === activeMetal?.id,
          )?.Double_Variants?.find((s) => s.id === activeSize?.id)
            ?.Triple_Variants?.length > 0 &&
            Number(product?.variant_type_id) ===
              Number(variant_type.Triple) && (
              <div className="quantity_holder">
                <p className="type_text">
                  Diamond: <strong>{activeTriple?.Diamond?.name}</strong>
                </p>
                <div className="variant_pill_grid">
                  {product.Product_Variants.find(
                    (v) => v.id === activeMetal?.id,
                  )
                    .Double_Variants.find((s) => s.id === activeSize?.id)
                    .Triple_Variants.map((item1) => (
                      <div
                        key={item1.id}
                        className={`variant_pill ${
                          activeTriple?.id === item1.id ? "active" : ""
                        }`}
                        onClick={() => {
                          setActiveTriple(item1);
                          if (
                            product?.variant_type_id === variant_type.Triple
                          ) {
                            setSelectedVariant(item1);
                          }
                        }}
                      >
                        {item1?.Diamond?.name}
                      </div>
                    ))}
                </div>
              </div>
            )}
        </div>

        <div className="amazon_btn_group">
          {/* <div className="qty_wrapper">
            {Number(selectedVariant?.general_stock) >= Number(quantity) && (
              <Increment_decrement_btn_holder
                quantity={quantity}
                setQuantity={setQuantity}
              />
            )}
          </div> */}
          {(product?.variant_type_id === 1
            ? selectedVariant?.general_stock
            : selectedVariant?.stock) <= 0 ? (
            <div className="cart_wrapper">
              <button className="amazon_add_btn">Out Of Stock</button>
            </div>
          ) : (
            <div className="cart_wrapper">
              <button className="amazon_add_btn" onClick={addToCart}>
                Add to Cart
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Product_info;
